import {StyleSearchFilter} from "./model";

export const filterReducer = (state: StyleSearchFilter = {}, action) => {
  switch (action.type) {
  case "controlRoom/SET_STYLES_FILTER":
    return Object.assign({}, action.payload.filter);
  }
  return state;
};